/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeALeftIcon20Regular = forwardRef('ArrowShapeALeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.228 11.588a2.25 2.25 0 0 1 0-3.18l6.967-6.976c.85-.851 2.306-.25 2.306.954V5.25H16a2 2 0 0 1 2 2v5.5a2 2 0 0 1-2 2h-4.5v2.861c0 1.203-1.456 1.806-2.306.954l-6.967-6.977Zm1.062-2.12a.75.75 0 0 0 0 1.06l6.71 6.72V14a.75.75 0 0 1 .75-.75H16a.5.5 0 0 0 .5-.5v-5.5a.5.5 0 0 0-.5-.5h-5.25A.75.75 0 0 1 10 6V2.748l-6.71 6.72Z" })));
});
